export const documentTypes = [
  {
    label: "About Prachay",
    value: "ABOUT_PRACHAY",
  },
  { label: "About ICDs", value: "ABOUT_ICD" },
  {
    label: "About Library",
    value: "ABOUT_LIBRARY",
  },
]

export const sectors = [
  {
    label: "Manufacturing",
    key: "MANUFACTURING",
  },
  {
    label: "Information Technology",
    key: "INFORMATION_TECHNOLOGY",
  },
  {
    label: "Healthcare",
    key: "HEALTHCARE",
  },
  {
    label: "Real Estate",
    key: "REAL_ESTATE",
  },
  {
    label: "NBFC",
    key: "NBFC",
  },
  {
    label: "Banking & Financial Services",
    key: "BANKING_FINANCIAL_SERVICES",
  },
  {
    label: "E-commerce",
    key: "E_COMMERCE",
  },
  {
    label: "Infrastructure",
    key: "INFRASTRUCTURE",
  },
  {
    label: "Insurance",
    key: "INSURANCE",
  },
  {
    label: "Others, please specify",
    key: "OTHERS",
  },
]
export const creditRatings = [
  {
    label: "AAA",
    key: "AAA",
  },
  {
    label: "AA+",
    key: "AA+",
  },
  {
    label: "AA",
    key: "AA",
  },
  {
    label: "AA-",
    key: "AA-",
  },
  {
    label: "A+",
    key: "A+",
  },
  {
    label: "A",
    key: "A",
  },
  {
    label: "A-",
    key: "A-",
  },
  {
    label: "BBB+",
    key: "BBB+",
  },
  {
    label: "BBB",
    key: "BBB",
  },
  {
    label: "BBB-",
    key: "BBB-",
  },
  {
    label: "BB+",
    key: "BB+",
  },
  {
    label: "BB",
    key: "BB",
  },
  {
    label: "BB-",
    key: "BB-",
  },
  {
    label: "B+",
    key: "B+",
  },
  {
    label: "B",
    key: "B",
  },
  {
    label: "B-",
    key: "B-",
  },
]
export const interestFrequency = [
  {
    label: "Monthly",
    key: "MONTHLY",
  },
  {
    label: "Quarterly",
    key: "QUARTERLY",
  },
  {
    label: "Half Yearly ",
    key: "HALF_YEARLY",
  },
  {
    label: "Yearly",
    key: "YEARLY",
  },
]

export const modeOfIssue = [
  {
    label: "Public",
    key: "PUBLIC",
  },
  {
    label: "Private",
    key: "PRIVATE",
  },
]

export const securityType = [
  {
    label: "Secured",
    key: "SECURED",
  },
  {
    label: "Unsecured",
    key: "UNSECURED",
  },
]

export const holdingType = [
  {
    label: "Physical",
    key: "PHYSICAL",
  },
  {
    label: "Demat",
    key: "DEMAT",
  },
]

export const ratingAgencies = [
  {
    label: "CRISIL",
    key: "CRISIL",
  },
  {
    label: "ICRA",
    key: "ICRA",
  },
  {
    label: "CARE Ratings",
    key: "CARE_RATINGS",
  },
  {
    label: "India Ratings & Research",
    key: "INDIA_RATINGS_RESEARCH",
  },
  {
    label: "Brickwork Ratings",
    key: "BRICKWORK_RATINGS",
  },
  {
    label: "Acuité Ratings & Research",
    key: "ACUITE_RATINGS_RESEARCH",
  },
  {
    label: "Infomerics Valuation and Rating Pvt Ltd",
    key: "INFOMERICS_VALUATION_RATING",
  },
  {
    label: "Others, please specify",
    key: "OTHERS",
  },
]

export const investorStatus = [
  {
    label: "Link Sent",
    key: "LINK_SENT",
  },
  {
    label: "Link Expired",
    key: "LINK_EXPIRED",
  },
  {
    label: "KYC Pending",
    key: "KYC_PENDING",
  },
  {
    label: "Under Review",
    key: "UNDER_REVIEW",
  },
  {
    label: "Agreement Shared",
    key: "ICD_AGREEMENT",
  },
  {
    label: "Query Raised",
    key: "QUERY_RAISED",
  },
  {
    label: "Invested",
    key: "INVESTED",
  },
  {
    label: "Approved",
    key: "APPROVED",
  },
  // {
  //   label: "Rejected",
  //   key: "REJECTED",
  // },
]

export const wealthPartnerStatus = [
  {
    label: "Link Sent",
    key: "LINK_SENT",
  },
  {
    label: "Link Expired",
    key: "LINK_EXPIRED",
  },
  {
    label: "KYC Pending",
    key: "KYC_PENDING",
  },
  {
    label: "Under Review",
    key: "UNDER_REVIEW",
  },
  {
    label: "Agreement Shared",
    key: "ICD_AGREEMENT",
  },
  {
    label: "Query Raised",
    key: "QUERY_RAISED",
  },
  {
    label: "Approved",
    key: "APPROVED",
  },
  // {
  //   label: "Rejected",
  //   key: "REJECTED",
  // },
]

export const icdRequestStatus = [
  {
    label: "Open",
    key: "OPEN",
  },
  {
    label: "Direct Acceptance",
    key: "DIRECT_ACCEPTANCE",
  },
  {
    label: "Counter Offer",
    key: "COUNTER_OFFER",
  },
  {
    label: "Rejected",
    key: "REJECTED",
  },
  {
    label: "Expired",
    key: "EXPIRED",
  },
  {
    label: "Term Sheet Shared",
    key: "TERM_SHEET_SHARED",
  },
  {
    label: "Term Sheet Finalised",
    key: "TERM_SHEET_FINALISED",
  },
  {
    label: "Funds in process",
    key: "FUNDS_IN_PROCESS",
  },
  {
    label: "Ongoing",
    key: "ONGOING",
  },
  {
    label: "Redeemed",
    key: "REDEEMED",
  },
]

export const userTypes = {
  ADMIN: "ADMIN",
  INVESTOR: "INVESTOR",
  WEALTH_PARTNER: "WEALTH_PARTNER",
}

export const integrationManagement = [
  {
    type: "HEADING",
    label: "Digio KYC Settings",
  },
  {
    type: "FIELD",
    key: "digioBaseUrl",
    label: "Base URL",
    value: "",
  },
  {
    type: "FIELD",
    key: "digioClientId",
    label: "Client ID",
    value: "",
  },
  {
    type: "FIELD",
    key: "digioClientSecret",
    label: "Client Secret",
    value: "",
  },
  {
    type: "FIELD",
    key: "digioWebhookSecret",
    label: "Webhook Secret",
    value: "",
  },
  {
    type: "FIELD",
    key: "digioICDSignPhoneNo",
    label: "ICD Signing Phone NO",
    value: "",
  },
  {
    type: "FIELD",
    key: "digioEstampEnabled",
    label: "Enable E-Stamp",
    value: "",
    options: [
      {
        label: "Enable",
        value: "ENABLED",
      },
      {
        label: "Disable",
        value: "DISABLED",
      },
    ],
  },
  {
    type: "FIELD",
    key: "digioEstampTag",
    label: "E-Stamp Tag Name",
    value: "",
  },
  {
    type: "FIELD",
    key: "digioICDFrameworkTemplateId",
    label: "ICD Master Agreement Template ID",
    value: "",
  },
  {
    type: "FIELD",
    key: "digioScheduleTermsTemplateId",
    label: "ICD Schedule Terms Template ID",
    value: "",
  },
  {
    type: "FIELD",
    key: "digioWPFrameworkTemplateId",
    label: "WP Agreement Template ID",
    value: "",
  },
  {
    type: "HEADING",
    label: "ICD Master Agreement settings",
  },
  {
    type: "FIELD",
    key: "icdMinTenure",
    label: "Minimum Tenure For ICDS(in months)",
    value: "",
  },
  {
    type: "FIELD",
    key: "icdMinInvestmentAmount",
    label: "Minimum investment Amount(INR)",
    value: "",
  },
  // {
  //   type: "HEADING",
  //   label: "SendGrid Settings",
  // },
  // {
  //   type: "FIELD",
  //   key: "sendGridApiKey",
  //   label: "API Key",
  //   value: "",
  // },
  // {
  //   type: "FIELD",
  //   key: "sendGridSender",
  //   label: "Sender Email",
  //   value: "",
  // },
  // {
  //   type: "FIELD",
  //   key: "sendGridInviteTemplate",
  //   label: "Invite Template ID",
  //   value: "",
  // },
  // {
  //   type: "FIELD",
  //   key: "sendGridInviteOTPTemplate",
  //   label: "OTP Template ID",
  //   value: "",
  // },
  {
    type: "HEADING",
    label: "Brevo Settings",
  },
  {
    type: "FIELD",
    key: "brevoApiKey",
    label: "API Key",
    value: "",
  },

  {
    type: "FIELD",
    key: "brevoEmailEnabled",
    label: "Enable/Disable Email Sending",
    value: "",
    options: [
      {
        label: "Enable",
        value: "ENABLED",
      },
      {
        label: "Disable",
        value: "DISABLED",
      },
    ],
  },
  {
    type: "FIELD",
    key: "brevoWelcomeTemplate",
    label: "Welcome to verify",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoWelcomeTemplateWp",
    label: "Welcome to verify(WP)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoWelcomeAdminTemplate",
    label: "Welcome to verify(Admin User)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoWelcomeInvestorUserTemplate",
    label: "Welcome to verify(Investor User)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoInviteInvestorReferalTemplate",
    label: "Invite Referal Investor(WP User)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoWpDeletedNotifyInvestorTemplate",
    label: "WP account Deleted (Infrom Referred Investors)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoAccountDeletedPermanently", //65
    label: "Account Deleted Permanently",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoAccountDeletedPermanentlyWp", //64
    label: "Account Deleted Permanently(WP)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKycPendingTemplate",
    label: "KYC Pending",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKycPendingTemplateWp",
    label: "KYC Pending(WP)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoOTPTemplate",
    label: "OTP Template ID",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoOTPTemplateWp",
    label: "OTP Template ID (WP)", //54
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKYCUnderApproval",
    label: "KYC under approval",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKYCQueryRaised",
    label: "KYC Query",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKYCQueryRaisedWp",
    label: "KYC Query(WP)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKYCICDFrameworkShared",
    label: "KYC approved, agreement for signing",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKYCICDFrameworkSharedWp",
    label: "KYC approved, agreement for signing(WP)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoSAOGeneratedTemplate",
    label: "Statement of Account generated",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoFundRequirementTemplate",
    label: "Fund Requirement by Prachay",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoOfferApprovedTemplate",
    label: "Offer Approved",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoOfferApprovedWealthPartnerBehalfTemplate",
    label: "Offer Approved(Wealth Partner Behalf)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoOfferRejectedTemplate",
    label: "Offer rejected",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoOfferRejectedWealthPartnerBehalfTemplate",
    label: "Offer Rejected(Wealth Partner Behalf)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoCounterOfferWealthPartnerBehalfTemplate",
    label: "Counter Offer(Wealth Partner Behalf)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoCounterOfferPlacedTemplate",
    label: "Counter-Offer placed(ADMIN)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoOfferPlacedByInvestorTemplate",
    label: "Offer placed by Investor",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoOfferPlacedByWpOnInvestorBehalfTemplate",
    label: "Offer placed by WP on Investor behalf",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoCompleteYourPaymentTemplate",
    label: "Send Payment Notification",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoPaymentCompletedTemplate",
    label: "Payment Completed Successfully",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoPaymentFailedTemplate",
    label: "Payment Failed",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoCompletePaymentAfterSigning",
    label: "Make Payment after Signing Schedule",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoForgotPasswordTemplate",
    label: "Forgot Password",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoPasswordResetTemplate",
    label: "Password Reset Successfully",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoPasswordChangeConfirmationTemplate",
    label: "Password Changed Successfully",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoDeleteAccountTemplate",
    label: "Account Delete Initiated",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoDeleteAccountTemplateWP",
    label: "Account Delete Initiated(WP)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoAccountDeletedConfirmationTemplate",
    label: "Account Deleted Confirmation",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKYCUpdateSubmitted",
    label: "Profile Update Acknowledgment",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKYCUpdateSubmittedWp",
    label: "Profile Update Acknowledgment(WP)", //56
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKYCUpdateApproved",
    label: "Profile Update Approved",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKYCUpdateApprovedWp",
    label: "Profile Update Approved(WP)", //57
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKYCUpdateRejected",
    label: "Profile Update Rejected",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoKYCUpdateRejectedWp",
    label: "Profile Update Rejected(WP)", // 58
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoOldEmailAddressOTPVerificationTemplate",
    label: "Old Email Address Change OTP Verification",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoOldEmailAddressOTPVerificationTemplateWp",
    label: "Old Email Address Change OTP Verification(WP)", //59
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoEmailAddressOTPVerificationTemplate",
    label: "Email Address Change OTP Verification",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoEmailAddressOTPVerificationTemplateWp",
    label: "Email Address Change OTP Verification(WP)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoEmailAddressUpdateConfirmation",
    label: "Email Address Update Confirmation",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoEmailAddressUpdateConfirmationWp",
    label: "Email Address Update Confirmation(WP)", //61
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoPhoneNumberUpdateConfirmation",
    label: "Phone Number Update Confirmation",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoPhoneNumberUpdateConfirmationWp",
    label: "Phone Number Update Confirmation(WP)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoMasterAgreementAccounts",
    label: "ICD Master Agreement(Accounts Team)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoScheduleAgreementAccounts",
    label: "ICD Schedule Terms(Accounts Team)",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoInvestorOnboarded",
    label: "Investor Onboarding Template",
    value: "",
  },
  {
    type: "FIELD",
    key: "brevoAccessToWealthPartnerByInvestorTemplate",
    label: "Access to Wealth Partner by Investor",
    value: "",
  },
  {
    type: "HEADING",
    label: "SMS Settings",
  },
  {
    type: "FIELD",
    key: "smsApiBaseUrl",
    label: "Base URL",
    value: "",
  },
  {
    type: "FIELD",
    key: "smsApiBaseUrlEnabled",
    label: "Enable/Disable SMS Sending",
    value: "",
    options: [
      {
        label: "Enable",
        value: "ENABLED",
      },
      {
        label: "Disable",
        value: "DISABLED",
      },
    ],
  },
  {
    type: "FIELD",
    key: "smsUsername",
    label: "Username",
    value: "",
  },
  {
    type: "FIELD",
    key: "smsPassword",
    label: "Password",
    value: "",
  },
  {
    type: "FIELD",
    key: "smsSenderId",
    label: "Sender ID",
    value: "",
  },
  {
    type: "FIELD",
    key: "smsTemplateId",
    label: "Template Id",
    value: "",
  },
  {
    type: "HEADING",
    label: "Cash Free Payment",
  },
  {
    type: "FIELD",
    key: "cashFreeBaseUrl",
    label: "Base Url",
    value: "",
  },
  {
    type: "FIELD",
    key: "cashFreeAppId",
    label: "App ID",
    value: "",
  },
  {
    type: "FIELD",
    key: "cashFreeSecretKey",
    label: "Secret Key",
    value: "",
  },
]

export const repaymentSchedule = [
  {
    label: "Single Installment",
    key: "SINGLE",
  },
  // {
  //   label: "Multiple Installments",
  //   key: "MULTIPLE",
  // },
]

export const fundAvailabilityTypes = [
  {
    label: "Immediate",
    key: "IMMEDIATE",
  },
  {
    label: "Later",
    key: "LATER",
  },
]

export const allStates = [
  {
    key: "AN",
    name: "Andaman and Nicobar Islands",
  },
  {
    key: "AP",
    name: "Andhra Pradesh",
  },
  {
    key: "AR",
    name: "Arunachal Pradesh",
  },
  {
    key: "AS",
    name: "Assam",
  },
  {
    key: "BR",
    name: "Bihar",
  },
  {
    key: "CG",
    name: "Chandigarh",
  },
  {
    key: "CH",
    name: "Chhattisgarh",
  },
  {
    key: "DH",
    name: "Dadra and Nagar Haveli and Daman & Diu",
  },
  {
    key: "DL",
    name: "Delhi",
  },
  {
    key: "GA",
    name: "Goa",
  },
  {
    key: "GJ",
    name: "Gujarat",
  },
  {
    key: "HR",
    name: "Haryana",
  },
  {
    key: "HP",
    name: "Himachal Pradesh",
  },
  {
    key: "JK",
    name: "Jammu and Kashmir",
  },
  {
    key: "JH",
    name: "Jharkhand",
  },
  {
    key: "KA",
    name: "Karnataka",
  },
  {
    key: "KL",
    name: "Kerala",
  },
  {
    key: "DD",
    name: "Ladakh",
  },
  {
    key: "LD",
    name: "Lakshadweep",
  },
  {
    key: "MP",
    name: "Madhya Pradesh",
  },
  {
    key: "MH",
    name: "Maharashtra",
  },
  {
    key: "MN",
    name: "Manipur",
  },
  {
    key: "ML",
    name: "Meghalaya",
  },
  {
    key: "MZ",
    name: "Mizoram",
  },
  {
    key: "NL",
    name: "Nagaland",
  },
  {
    key: "OR",
    name: "Odisha",
  },
  {
    key: "PY",
    name: "Puducherry",
  },
  {
    key: "PB",
    name: "Punjab",
  },
  {
    key: "RJ",
    name: "Rajasthan",
  },
  {
    key: "SK",
    name: "Sikkim",
  },
  {
    key: "TN",
    name: "Tamil Nadu",
  },
  {
    key: "TS",
    name: "Telangana",
  },
  {
    key: "TR",
    name: "Tripura",
  },
  {
    key: "UK",
    name: "Uttar Pradesh",
  },
  {
    key: "UP",
    name: "Uttarakhand",
  },
  {
    key: "WB",
    name: "West Bengal",
  },
]

export const reactSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    boxShadow: state.isFocused ? "none" : provided.boxShadow,
    border: state.isFocused ? "none" : provided.border,
    border: `1px solid ${state.isFocused ? "#C9C9C9" : "#C9C9C9"}`,
    borderRadius: "8px",
    boxShadow: "none",
    minHeight: "40px",
    minWidth: "100%",
    width: "100%",
    outline: "none",
    position: "relative",
    fontSize: "14px",
    fontWeight: "400",
    color: "#414141",
    "&:hover": {
      borderColor: "#C9C9C9",
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    width: "100%",
    minWidth: "100%",
  }),
  container: (provided) => ({
    ...provided,
    width: "100%",
  }),

  option: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    fontWeight: "400",
    color: state.isSelected ? "#414141" : "#414141",
    backgroundColor: state.isSelected ? "#035ca133" : "#FFFFFF",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#035ca133",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "14px",
    fontWeight: "400",
    color: "#414141",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "14px",
    fontWeight: "400",
    color: "#414141",
  }),
  input: (provided) => ({
    ...provided,
    fontSize: "14px",
    fontWeight: "400",
    color: "#414141",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),

  menuPortal: (base) => ({ ...base, zIndex: 9999 }),

  clearIndicator: (base) => ({
    ...base,
    // zIndex: 0,
  }),
  menuList: (base) => ({
    ...base,

    "&::-webkit-scrollbar": {
      width: "8px",
      height: "5px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#C9C9C9",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#C9C9C9",
    },
  }),
}

export function formatIndianNumber(num = 0) {
  const absNum = Math.abs(num)
  const isValueDecimal = absNum % 1 !== 0
  const setDigitsAfter = isValueDecimal ? 2 : 0
  let formatted = ""

  if (absNum >= 1e7) {
    formatted = (num / 1e7).toFixed(setDigitsAfter) + " Cr"
  } else if (absNum >= 1e5) {
    formatted = (num / 1e5).toFixed(setDigitsAfter) + " Lakh"
  } else if (absNum >= 1e3) {
    formatted = (num / 1e3).toFixed(setDigitsAfter) + " K"
  } else {
    formatted = num.toFixed(setDigitsAfter).toString()
  }

  return formatted
}

export function formatIndianCurrency(num = 0) {
  const absNum = Math.abs(num)
  const isValueDecimal = absNum % 1 !== 0
  const setDigitsAfter = isValueDecimal ? 2 : 0

  const formatted = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: setDigitsAfter,
    maximumFractionDigits: setDigitsAfter,
  }).format(num)

  return formatted
}

export function formatIndianNumberinCr(num = 0) {
  const croreValue = num / 1e7
  const formatted = croreValue.toFixed(2) + " Cr"
  return formatted
}

export const formatName = (str = "", splitBy = "_") => {
  return str.split(splitBy).join(" ")
}

export const copyToClipboard = (text) => {
  return navigator.clipboard.writeText(text)
}

export const businessFiles = [
  { key: "initial_partnership_deed", label: "Partnership Deed" },
  { key: "latest_partnership_deed", label: "Supplemental Partnership Deed" },
  {
    key: "certificate_of_incorporation",
    label: "Certificate of Incorporation",
  },
  { key: "gstin_certificate", label: "GSTIN Certificate" },
  { key: "registration_certificate", label: "Registration Certificate" },
  { key: "memorandum_of_association", label: "Memorandum of Association" },
  { key: "articles_of_association", label: "Articles of Association" },
  { key: "initial_llp_deed", label: "Initial LLP Agreement" },
  { key: "latest_llp_deed", label: "Supplemental LLP Agreement" },
  { key: "huf_creation_document", label: "HUF Creation Document" },
  { key: "trust_deed", label: "Trust Deed" },
  { key: "society_bye_laws", label: "Society Bye-laws" },
]
